import { retrieveTimestamp } from '../../service/timestampService';
import timestampStyles from '../../styles/UI/TimeStamp.module.css';

export const Timestamp = ({ date, classes }: { date: string; classes?: string }) => {
	const classList = `${timestampStyles.timestamp} ${classes ? classes : ''}`;
	const timestamp = date ? retrieveTimestamp(date) : null;

	return <p className={classList}>{timestamp}</p>;
};
